import '../../quickview.scss';

import { createAvailableRecommendationBlocks } from '@boost-sd/theme/core/blocks/recommendation';

const blocks = createAvailableRecommendationBlocks();

blocks.render();
